<template>
  <div class="pb-section-container margin-top-16">
    <div :class="['pbs-header-container', active ? 'active' : null]">
      <button
        v-if="finishedSection.includes('signUpBonus') && !active"
        type="button"
        class="pbs-done-button"
        @click="changeActiveStepIdx(index)"
      >
        Edit
      </button>
      <button
        v-else-if="!active"
        type="button"
        class="pbs-button"
        @click="changeActiveStepIdx(index)"
      >
        Start
      </button>
      <button v-else type="button" class="pbs-close-button" @click="changeActiveStepIdx(-1)">
        <img src="@shared/assets/img/setting/chevron-up.svg" alt="Close" />
      </button>
      <div class="pbs-header">Sign Up Bonuses</div>
      <div v-if="finishedSection.includes('signUpBonus')" class="pbs-header-right-container">
        <div class="pbs-check-container">
          <img src="@shared/assets/img/general/check-white.png" alt="Done" />
        </div>
      </div>
    </div>
    <div
      :class="[
        'pbs-body-container signup-section',
        active ? 'active' : null,
        comfortCredit && filterVoucher ? 'larger' : null,
        (comfortCredit && !filterVoucher) || (!comfortCredit && filterVoucher) ? 'medium' : null,
      ]"
    >
      <div class="pbs-body">Incentivize your customers by including a sign-up bonus.</div>
      <div class="pbs-checkbox-container">
        <input
          id="signup-credit"
          v-model="comfortCredit"
          type="checkbox"
          class="pbs-checkbox"
          :disabled="none"
        />
        <label for="signup-credit" class="pbs-checkbox-label">
          Comfort Credits Sign Up Bonus (one time at sign-up)
        </label>
      </div>
      <div v-if="comfortCredit" class="pbs-input-container margin-top-4 margin-left-18">
        <div class="pbs-input-container">
          <label for="bonus-comfort-credit" class="pbs-input-label">
            <img src="@shared/assets/img/setting/cc-icon.svg" alt="Rewards" />
            Comfort Credits Bonus
          </label>
          <div class="flex-row align-end">
            <input
              id="bonus-comfort-credit"
              v-model="bonusComfortCredit"
              class="pbs-input width-20"
              placeholder="$0"
              @keypress="isNumber"
            />
          </div>
        </div>
        <div class="pbs-input-container margin-top-8">
          <label for="signup-bonus-application" class="pbs-input-label">
            Sign-up bonus should be awarded per
          </label>
          <select id="signup-bonus-application" v-model="SignupBonusAccrual" class="pbs-select">
            <option :value="null">Same as monthly accumulation</option>
            <option value="Member">Member</option>
            <option value="Hub">System</option>
            <option value="Location">Location</option>
          </select>
        </div>
      </div>
      <div class="pbs-checkbox-container margin-top-16">
        <input
          id="signup-voucher"
          v-model="filterVoucher"
          type="checkbox"
          class="pbs-checkbox"
          :disabled="none"
        />
        <label for="signup-voucher" class="pbs-checkbox-label">
          Filter Voucher for discounts at checkout
        </label>
      </div>
      <div v-if="filterVoucher" class="pbs-input-container margin-top-4 margin-left-18">
        <div class="pbs-input-container">
          <label for="bonus-filter-voucher" class="pbs-input-label">
            <img src="@shared/assets/img/setting/filter-icon.svg" alt="Voucher" />
            Filter Voucher for discounts at checkout
          </label>
          <div class="flex-row align-end">
            <input
              id="bonus-filter-voucher"
              v-model="bonusFilterVoucher"
              class="pbs-input width-20"
              placeholder="$0"
              @keypress="isNumber"
            />
          </div>
        </div>
        <div class="pbs-input-container margin-top-8">
          <label for="voucher-accrual-method" class="pbs-input-label">
            Filter Voucher should be awarded per
          </label>
          <select id="voucher-accrual-method" v-model="voucherAccrualMethod" class="pbs-select">
            <option value="Hub">System</option>
            <option value="Subscriber">Member</option>
          </select>
        </div>
        <div class="pbs-input-container margin-top-8">
          <label for="credit-accrual-method" class="pbs-input-label"> Select Frequency </label>
          <select
            v-model="bonusFilterVoucherFrequency"
            class="pbs-select"
            aria-label="Filter Voucher Frequency"
          >
            <option value="One time">One time</option>
            <option value="Yearly">Yearly</option>
          </select>
        </div>
      </div>
      <div class="pbs-checkbox-container margin-top-16">
        <input id="signup-none" v-model="none" type="checkbox" class="pbs-checkbox" />
        <label for="signup-none" class="pbs-checkbox-label"> None </label>
      </div>
      <div class="pbs-button-container">
        <button
          type="button"
          class="pbs-grey-button"
          :disabled="
            (!comfortCredit && !filterVoucher && !none) ||
            (comfortCredit && !bonusComfortCredit) ||
            (filterVoucher && !bonusFilterVoucher)
          "
          @click="handleContinue"
        >
          Continue
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import formatterMixin from '@shared/mixins/formatterMixin';
import { debounce } from 'lodash';

export default {
  name: 'SignUpBonus',
  mixins: [formatterMixin],
  props: {
    editing: Boolean,
    index: Number,
    active: Boolean,
    changeActiveStepIdx: Function,
    plan: Object,
    updatePlan: Function,
    finishedSection: Array,
    markUnfinishedSection: Function,
    markFinishedSection: Function,
  },
  data() {
    return {
      comfortCredit: false,
      filterVoucher: false,
      none: false,
      bonusComfortCredit: null,
      creditAccrualMethod: null,
      bonusFilterVoucherFrequency: null,
      bonusFilterVoucher: null,
      voucherAccrualMethod: null,
      SignupBonusAccrual: null,
    };
  },
  watch: {
    comfortCredit(val) {
      if (val) {
        this.none = false;
        if (!this.creditAccrualMethod) {
          this.creditAccrualMethod = 'Hub';
        }
      }
      this.checkIfIncomplete();
    },
    filterVoucher(val) {
      if (val) {
        this.none = false;
        if (!this.bonusFilterVoucherFrequency) {
          this.bonusFilterVoucherFrequency = 'Yearly';
        }
        if (!this.voucherAccrualMethod) {
          this.voucherAccrualMethod = 'Hub';
        }
      }
      this.checkIfIncomplete();
    },
    none(val) {
      if (val) {
        this.comfortCredit = false;
        this.filterVoucher = false;
        this.bonusFilterVoucherFrequency = null;
        this.voucherAccrualMethod = null;
      }
      this.checkIfIncomplete();
    },
    plan(newPlan) {
      this.comfortCredit = newPlan.bonusComfortCredit > 0;
      this.filterVoucher = newPlan.bonusFilterVoucher > 0;
      if (this.editing) {
        this.none = !newPlan.bonusComfortCredit && !newPlan.bonusFilterVoucher;
      } else if (!this.finishedSection.includes('signUpBonus')) {
        this.none = false;
      }
      this.bonusComfortCredit = newPlan.bonusComfortCredit;
      this.bonusFilterVoucher = newPlan.bonusFilterVoucher;
      if (newPlan.creditAccrualMethod) {
        this.creditAccrualMethod = newPlan.creditAccrualMethod;
      }
      if (newPlan.voucherAccrualMethod) {
        this.voucherAccrualMethod = newPlan.voucherAccrualMethod;
      }
      if (newPlan.bonusFilterVoucherFrequency) {
        this.bonusFilterVoucherFrequency = newPlan.bonusFilterVoucherFrequency;
      }
      const signupAccrual = newPlan.SignupBonusAccrual || newPlan.signupBonusAccrual;
      if (signupAccrual) {
        this.SignupBonusAccrual = signupAccrual === 'Subscriber'
          ? 'Member'
          : signupAccrual === 'Hub'
            ? 'Hub'
            : signupAccrual === 'Location'
              ? 'Location'
              : null;
      } else {
        this.SignupBonusAccrual = null;
      }
    },
    bonusComfortCredit() {
      this.checkIfIncomplete();
    },
    creditAccrualMethod() {
      this.checkIfIncomplete();
    },
    bonusFilterVoucherFrequency() {
      this.checkIfIncomplete();
    },
    bonusFilterVoucher() {
      this.checkIfIncomplete();
    },
    voucherAccrualMethod() {
      this.checkIfIncomplete();
    },
    SignupBonusAccrual() {
      this.checkIfIncomplete();
    },
  },
  methods: {
    handleContinue() {
      this.changeActiveStepIdx(this.index + 1);
      const newPlan = {
        ...this.plan,
      };
      if (this.comfortCredit) {
        newPlan.bonusComfortCredit = this.bonusComfortCredit;
        const value = this.SignupBonusAccrual === 'Member'
          ? 'Subscriber'
          : this.SignupBonusAccrual;
        newPlan.SignupBonusAccrual = value;
        newPlan.signupBonusAccrual = value;
      } else {
        newPlan.bonusComfortCredit = null;
        newPlan.SignupBonusAccrual = null;
        newPlan.signupBonusAccrual = null;
      }
      if (this.filterVoucher) {
        newPlan.bonusFilterVoucherFrequency = this.bonusFilterVoucherFrequency;
        newPlan.bonusFilterVoucher = this.bonusFilterVoucher;
        newPlan.voucherAccrualMethod = this.voucherAccrualMethod;
      } else {
        newPlan.bonusFilterVoucherFrequency = null;
        newPlan.bonusFilterVoucher = null;
        newPlan.voucherAccrualMethod = null;
      }
      this.updatePlan(newPlan, 'signUpBonus');
    },
    checkIfIncomplete: debounce(function () {
      if (this.editing || this.finishedSection.includes('signUpBonus')) {
        let incomplete = false;
        const compareComfort = this.bonusComfortCredit || 0;
        const compareVoucher = this.bonusFilterVoucher || 0;
        const planComfort = this.plan.bonusComfortCredit || 0;
        const planVoucher = this.plan.bonusFilterVoucher || 0;
        if (
          (this.comfortCredit && this.plan.bonusComfortCredit === 0) ||
          (!this.comfortCredit && this.plan.bonusComfortCredit > 0) ||
          Number(compareComfort) !== Number(planComfort)
        ) {
          incomplete = true;
        }
        if (
          (this.filterVoucher && this.plan.bonusFilterVoucher === 0) ||
          (!this.filterVoucher && this.plan.bonusFilterVoucher > 0) ||
          Number(compareVoucher) !== Number(planVoucher)
        ) {
          incomplete = true;
        }
        if (this.creditAccrualMethod !== this.plan.creditAccrualMethod && planComfort > 0) {
          incomplete = true;
        }
        if (this.bonusFilterVoucherFrequency !== this.plan.bonusFilterVoucherFrequency) {
          incomplete = true;
        }
        if (this.voucherAccrualMethod !== this.plan.voucherAccrualMethod) {
          incomplete = true;
        }
        const convertedSignupBonus = this.SignupBonusAccrual === 'Member'
          ? 'Subscriber'
          : this.SignupBonusAccrual;
        const planSignupAccrual = this.plan.SignupBonusAccrual || this.plan.signupBonusAccrual;
        if (convertedSignupBonus !== planSignupAccrual && planComfort > 0) {
          incomplete = true;
        }
        if (incomplete) {
          this.markUnfinishedSection('signUpBonus');
        } else {
          this.markFinishedSection('signUpBonus');
        }
      }
    }, 500),
  },
};
</script>
